import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Content from './Content';

const useStyles = makeStyles((theme) => ({
  
}));

function ColorSettings(props) {
  const classes = useStyles();
  
  return (
    <Content>
      <h1>Color settings</h1>
    </Content>
  );
}

export default ColorSettings;
